export default __webpack_public_path__ + "static/media/bird-with-confetti.4c16aaa7.svg";